(function () {
  function init() {
    var hero = document.querySelector('[data-viola-hero-logo]');
    if (!hero) return;

    if (hero.classList.contains('hero-logo--has-image')) {
      document.body.classList.add('viola-hero-has-image');
    }

    // 2026-08-26: the logo-morph (big centered mark shrinking into the nav
    // logo on scroll) was removed per explicit request — the nav logo now
    // always sits in the header, full-time, and the big hero mark is a
    // normal static piece of hero content instead of a fixed/animated
    // element. All that's left to drive off scroll position is: (1) the
    // nav bar's transparent -> slightly-tinted background, and (2) the
    // nav text/icons swapping white -> black — both keyed off the single
    // `viola-scrolled` body class below, past a small threshold so it
    // doesn't flicker right at the very top.
    var SCROLL_THRESHOLD = 40;
    var ticking = false;
    var docked = false;

    function update() {
      ticking = false;
      var scrolled = window.scrollY > SCROLL_THRESHOLD;
      if (scrolled && !docked) {
        docked = true;
        document.body.classList.add('viola-scrolled');
      } else if (!scrolled && docked) {
        docked = false;
        document.body.classList.remove('viola-scrolled');
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Real bug seen live: Safari's back-forward cache freezes the page
    // (and this script's closures, including `docked`) exactly as it was
    // when the shopper navigated away — e.g. scrolled down, docked=true.
    // Restoring from bfcache does NOT re-fire DOMContentLoaded, so without
    // this the nav could come back looking "stuck" scrolled/dark even
    // though the restored page is sitting at the top. `pageshow` fires on
    // both a normal load and a bfcache restore (`event.persisted` is true
    // only for the latter) — re-run update() either way so the nav state
    // always matches the real current scroll position.
    window.addEventListener('pageshow', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
